/**
 * Strategy Registry
 * Central export for all campaign section strategies
 * Open/Closed: Add new strategies here without modifying existing code
 */

import type { CampaignSectionStrategy } from '../../MultiViewCampaignSection/types';
import type { CampaignSource } from '../../../types/campaign.types';
import { prizePopStrategy } from './prizePopStrategy';
import { tournamentStrategy } from './tournamentStrategy';
import { rebateStrategy } from './rebateStrategy';

/** Strategy registry - maps section names to their strategies */
const strategyRegistry: Record<string, CampaignSectionStrategy<CampaignSource>> = {
  'prize-pop': prizePopStrategy,
  'tournaments': tournamentStrategy,
  'rebate': rebateStrategy,
};

/** Get strategy by section type */
export const getStrategy = (sectionType: string): CampaignSectionStrategy<CampaignSource> | undefined => {
  return strategyRegistry[sectionType];
};
